<template>
    <div>
        <remote-select
            v-model="selectedUser"
            @focus="fetchUsers"
            :remote-method="fetchUsers"
            :loading="loadingUsers"
            @input="changed"
            :data="users"
            item-label="name"
            placeholder="Start typing to search users">
            <template slot-scope="props">
                <span>{{ props.item.name }}</span>
            </template>
        </remote-select>
    </div>
</template>

<script>
export default {
    props: ["value", "portfolioId"],

    data () {
        return {
            selectedUser: this.value,
            loadingUsers: false,
            users: []
        };
    },

    watch: {
        portfolioId () {
            this.fetchUsers();
        }
    },

    mounted () {
        this.fetchUsers();
        this.$nextTick(function () {
            this.selectedUser = this.value;
        });
    },

    methods: {
        changed () {
            this.$emit("input", this.selectedUser);
        },

        fetchUsers: _.debounce(function (input) {
            axios.get("/users", {
                "params": {
                    search_text: input,
                    per_page: 30,
                    status: "active",
                    user_type: "team_users",
                    portfolio_id: this.portfolioId ? this.portfolioId : null,
                }
            })
            .then(response => {
                this.users = response.data.data;

                if (this.portfolioId && this.selectedUser) {
                    if (this.users.filter(user => this.selectedUser.id === user.id).length === 0) {
                        this.selectedUser = null;
                        this.changed();
                    }
                }
            })
            .catch(errors => {
                toastr.error(errors.message);
            });
        }, 300),
    },
};
</script>